import React, { useState, useEffect } from 'react';
import { sixYardAxios } from '../../sixYardAxios';
import classes from '../../components/whatsNew/whatsNew.module.css';
import HeroSection from '../../components/whatsNew/hero/hero';
import LatestNews from '../../components/whatsNew/latestNews/latestNews';
import PlayersOfMonth from '../../components/whatsNew/playersOfMonth/playersOfMonth';

const WhatsNew = () => {
    const [heroSection, setHeroSection] = useState({});
    const [latestNews, setLatestNews] = useState([]);
    const [latestNewsTitle, setLatestNewsTitle] = useState("");
    const [playersOfMonth, setPlayersOfMonth] = useState([]);
    const [playersOfMonthTitle, setPlayersOfMonthTitle] = useState("");

    useEffect(() => { 
        fetchWhatsNews();
    }, [localStorage.getItem('language')]);

    const fetchWhatsNews = async () => {
        try {
            const res = await sixYardAxios.get("/whats-new");    
            setHeroSection(res.data.data.hero_banner);
            setLatestNews(res.data.data.latest_news.articles);
            setLatestNewsTitle(res.data.data.latest_news.section_title);
            setPlayersOfMonth(res.data.data.players_of_month.players);
            setPlayersOfMonthTitle(res.data.data.players_of_month.section_title);
        } catch (error) { }
    };

    return (
        <div className={classes.Container}>
            <HeroSection heroSection={heroSection}/>
            <LatestNews latestNews={latestNews} latestNewsTitle={latestNewsTitle}/>
            <PlayersOfMonth playersOfMonth={playersOfMonth} playersOfMonthTitle={playersOfMonthTitle}/>
        </div>
    )
}

export default WhatsNew;